import { useState } from 'react';

const resources = [
  {
    icon: 'ri-file-text-line',
    title: 'Teknik Teknik Rapor',
    desc: 'Düzenlenmiş özel bulutlar ile entegre Özel Bulut İşletim Sistemleri arasında mimari karşılaştırma.',
    link: 'https://www.verge.io/white-paper-evaluating-dell-private-cloud-vs-vergeos/',
    label: 'Teknik Raporu İndirin →',
  },
  {
    icon: 'ri-flow-chart',
    title: 'Karar Çerçevesi',
    desc: 'Satın alma tablolarının görmezden geldiği operasyonel maliyetleri ortaya çıkaran satıcı sorguları.',
    link: 'https://www.verge.io/infrastructure-decision-framework/',
    label: 'Çerçeveye Erişin →',
  },
  {
    icon: 'ri-book-open-line',
    title: 'Özel Bulut İşletim Sistemi Nedir?',
    desc: 'Sanallaştırmayı özel bulut mimarisinden ayıran özelliklerin derinlemesine analizi.',
    link: 'https://www.verge.io/blog/private-cloud/what-is-a-private-cloud-os/',
    label: 'Analizi Okuyun →',
  },
  {
    icon: 'ri-sword-line',
    title: 'Rekabetçi Karşılaştırma Kartı',
    desc: 'Dell Özel Bulutu ile VergeOS mimari karşılaştırması ve itiraz ele alma.',
    link: 'https://www.verge.io/contact/',
    label: 'Kartı İnceleyin →',
  },
  {
    icon: 'ri-article-line',
    title: 'Blog: Platform Migration',
    desc: 'Platformdan çıkan kuruluşlar için altyapı konsolidasyonunun hiper yönetici değişimini neden geride bıraktığı.',
    link: 'https://www.verge.io/blog/private-cloud/from-vmware-to-private-cloud/',
    label: 'Blogu Okuyun →',
  },
  {
    icon: 'ri-bar-chart-line',
    title: 'Vaka Çalışmaları',
    desc: 'VergeOS\'a geçen gerçek kuruluşlar — gerçek verimlilik kazanımları ve yatırım getirisi verileriyle.',
    link: 'https://www.verge.io/case-studies-registration-page/',
    label: 'Vaka Çalışmalarını Görün →',
  },
];

const faqs = [
  {
    q: 'Hiper yönetici değiştirme ile Özel Bulut İşletim Sistemi arasındaki fark nedir?',
    a: 'Hiper yönetici değiştirme, sanallaştırma katmanını değiştirir ve mevcut altyapı mimarisini olduğu gibi bırakır — ayrı depolama dizileri, ağ ürünleri ve yönetim araçları dahil. Özel Bulut İşletim Sistemi ise hesaplamayı, depolamayı, ağı ve veri korumasını tek bir birleşik platformda birleştirir. Hiper yönetici değiştirme lisans maliyetlerini çözer. Özel Bulut İşletim Sistemi, altyapı ekibinin zamanının %40-60\'ını tüketen operasyonel yükü çözer.',
  },
  {
    q: 'VergeOS mevcut donanımımızda çalışabilir mi?',
    a: 'Evet. VergeOS, Dell VxRail, HPE, Cisco, Lenovo ve standart x86 sunucular dahil her x86 sunucu donanımında çalışır. Sıfır sermaye yatırımıyla mevcut altyapınızda VergeOS\'u dağıtabilirsiniz. Platform düzeyinde verimlilik genellikle sunucu sayısını %30-40 azaltır; yani bugün kullandığınızdan daha az fiziksel sunucuda aynı iş yüklerini çalıştırabilirsiniz.',
  },
  {
    q: 'Diğer Platformlardan VergeOS\'a geçiş ne kadar sürer?',
    a: 'Çoğu kuruluş, ortam karmaşıklığına ve ekip uygunluğuna bağlı olarak geçişi 60-120 günde tamamlar. VergeOS, süreci hızlandırmak için geçiş araçları ve hizmetleri sunar. Birçok müşteri, risk ve operasyonel kesinti süresini en aza indirmek için geçiş süresince VergeOS paralel çalıştırarak iş yüklerini kademeli olarak taşır.',
  },
  {
    q: 'Mevcut depolama yatırımımıza ne olur?',
    a: 'VergeOS, platforma entegre kurumsal depolama özelliklerini kapsar — ayrı depolama dizisi gerekmez. Mevcut depolama dizileriniz varsa, VergeOS\'un entegre depolamasına geçiş yaparken geçiş süresince bunları kullanmaya devam edebilir, ardından yeniden amaçlandırabilir veya emekli edebilirsiniz.',
  },
  {
    q: 'VergeOS Dell Özel Bulutu veya Nutanix ile nasıl karşılaştırılır?',
    a: 'Dell Özel Bulutu ve Nutanix, ürünleri otomasyon katmanları aracılığıyla koordine eder — depolamayı, ağı ve veri korumasını hâlâ ayrı bileşenler olarak yönetirsiniz. VergeOS bunları tek bir yükseltme yolu, tek destek ilişkisi ve birleşik tanıyla tek bir platformda birleştirir. Bu mimari fark, daha düşük operasyonel yük, daha basit sorun giderme ve satıcı donanım kilidi olmamasına yansır.',
  },
  {
    q: 'Yüksek kullanılabilirlik ve felaket kurtarma gibi kurumsal özellikler var mı?',
    a: 'VergeOS, kurumsal özellikleri platforma dahil sunar — ek lisans gerekmez. Buna yerleşik yüksek kullanılabilirlik ve kümeleme, yerel çoğaltma ve felaket kurtarma, entegre yedekleme ve anlık görüntüler, Sanal Veri Merkezleriyle çok kiracılılık ve GPU sanallaştırma ile kesirli tahsis dahildir.',
  },
  {
    q: 'Altyapı ekipleri için öğrenme eğrisi nedir?',
    a: 'Diğer Platforma aşina ekipler genellikle 1-2 hafta içinde VergeOS ile verimli olmaya başlar. Platform, VM\'ler, ağlar ve depolama gibi tanıdık kavramları kullanır; ancak ayrı ürünleri koordine etme ihtiyacını ortadan kaldırarak operasyonları basitleştirir.',
  },
  {
    q: 'VergeOS nasıl lisanslanır ve fiyatlandırılır?',
    a: 'VergeOS, tüm özellikler dahil olmak üzere fiziksel CPU soketi başına lisanslanır — depolama, ağ, çoğaltma veya veri koruması için ayrı lisans yoktur. Fiyatlandırma şeffaf ve öngörülebilirdir, sonradan ihtiyaç duyacağınız özellikler için sürpriz maliyetler oluşmaz.',
  },
];

export default function OBResourcesFaq() {
  const [open, setOpen] = useState<number | null>(null);

  return (
    <>
      {/* Resources */}
      <section className="py-20 bg-[#f8fafc] border-t border-gray-100">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-3xl font-bold text-[#1e293b] text-center mb-12">Kararınıza Rehberlik Edecek Kaynaklar</h2>
          <div className="grid md:grid-cols-3 gap-5">
            {resources.map((r) => (
              <div key={r.title} className="bg-white rounded-lg border border-gray-100 p-6 flex flex-col">
                <span className="w-10 h-10 flex items-center justify-center bg-[#e8600a]/10 rounded-lg text-[#e8600a] mb-4">
                  <i className={`${r.icon} text-lg`}></i>
                </span>
                <h3 className="font-semibold text-[#1e293b] text-sm mb-2">{r.title}</h3>
                <p className="text-xs text-gray-500 leading-relaxed mb-4 flex-1">{r.desc}</p>
                <a
                  href={r.link}
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="text-xs font-semibold text-[#e8600a] hover:underline cursor-pointer"
                >
                  {r.label}
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-20 bg-white border-t border-gray-100">
        <div className="max-w-3xl mx-auto px-6">
          <h2 className="text-3xl font-bold text-[#1e293b] text-center mb-12">Sıkça Sorulan Sorular</h2>
          <div className="space-y-3">
            {faqs.map((faq, i) => (
              <div key={i} className="rounded-lg border border-gray-100 bg-[#f8fafc] overflow-hidden">
                <button
                  onClick={() => setOpen(open === i ? null : i)}
                  className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer"
                >
                  <span className="font-medium text-[#1e293b] text-sm pr-4">{faq.q}</span>
                  <span className="w-5 h-5 flex items-center justify-center text-gray-400 shrink-0">
                    <i className={`${open === i ? 'ri-subtract-line' : 'ri-add-line'} text-lg`}></i>
                  </span>
                </button>
                {open === i && (
                  <div className="px-6 pb-5 pt-1 text-sm text-gray-600 leading-relaxed border-t border-gray-100">
                    {faq.a}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
